import { StartEndLabel } from '@mi-front/ui';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, styled, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { useFocus } from '../../../stores/stream-screen.store';
import { useStreamSelection } from '../../../stores/useStreamSelection';

const LabelsContainer = styled(Box)({
  position: 'relative',
  width: '100%',
  marginTop: '0.5rem',
  minHeight: '1.5rem',
});

const LeftLabelsContainer = styled(Box)({
  position: 'absolute',
  left: 0,
  display: 'flex',
  flexDirection: 'row',
  gap: '0.25rem',
});

const RightLabelsContainer = styled(Box)({
  position: 'absolute',
  right: 0,
  display: 'flex',
  flexDirection: 'row',
  gap: '0.25rem',
});

export function SelectionOutOfRangeLabels() {
  const { $t } = useIntl();
  const tz = useTimezone();
  const focus = useFocus();
  const { selection, clearSelection } = useStreamSelection();
  const { tsA, tsB } = selection;

  const showStartLabelOnLeft = tsA && focus.from !== undefined && tsA < focus.from;
  const showStartLabelOnRight = tsA && focus.to !== undefined && focus.to < tsA;
  const showEndLabelOnLeft = tsB && focus.from !== undefined && focus.from > tsB;
  const showEndLabelOnRight = tsB && focus.to !== undefined && tsB > focus.to;

  if (
    !showStartLabelOnLeft &&
    !showStartLabelOnRight &&
    !showEndLabelOnLeft &&
    !showEndLabelOnRight
  ) {
    return null;
  }

  const hasLeftLabels = showStartLabelOnLeft || showEndLabelOnLeft;
  const hasRightLabels = showStartLabelOnRight || showEndLabelOnRight;

  const clearButton = (
    <Tooltip
      title={$t({
        id: 'logger.streamScreen.selection.clear',
        defaultMessage: 'Eliminar selección',
      })}
      placement="top"
    >
      <IconButton
        size="small"
        onClick={clearSelection}
        color="error"
        sx={{
          padding: '0.25rem',
        }}
      >
        <CloseIcon sx={{ fontSize: '16px' }} />
      </IconButton>
    </Tooltip>
  );

  return (
    <LabelsContainer>
      {hasLeftLabels && (
        <LeftLabelsContainer>
          {showStartLabelOnLeft && <StartEndLabel ts={tsA} isStart tz={tz} />}
          {showEndLabelOnLeft && <StartEndLabel ts={tsB} isEnd tz={tz} />}
          {!hasRightLabels && clearButton}
        </LeftLabelsContainer>
      )}
      {hasRightLabels && (
        <RightLabelsContainer>
          {showStartLabelOnRight && <StartEndLabel ts={tsA} isStart tz={tz} />}
          {showEndLabelOnRight && <StartEndLabel ts={tsB} isEnd tz={tz} />}
          {clearButton}
        </RightLabelsContainer>
      )}
    </LabelsContainer>
  );
}
